<template>
    <tippy class="relative inline-block text-left" :class="wrapperClasses" :tag="props.tag" :onShow="tippyShow" 
        :appendTo="docBody" :trigger="trigger" theme="transparent" :arrow="false" interactive animation="shift-away" :placement="props.placement || 'top'"
        :offset="offset" :maxWidth="maxWidth" :touch="true" :moveTransition="moveTransition" :onShown="tippyShown" :onHidden="tippyHidden" ref="theTippy">
    <!-- <div> -->
        <div v-if="trigger === 'click'" class="flex-1 cursor-pointer" @click="openDropdown" :class="triggerClasses" ref="dropdownTrigger">
            <slot v-if="!modelValueIsset"></slot>
            <div v-else class="px-2 py-1 rounded border text-gray-600 text-xs">
                <i v-if="icon" :class="icon"></i>
                {{ getText(modelValue) }}
                <button v-if="modelValue" @click="$event.stopPropagation(); emit('update:modelValue', null)">
                    <i class="fal fa-times fa-fw"></i>
                </button>
                <i v-else class="fal fa-chevron-down fa-fw"></i>
            </div>
        </div>
        <div v-else-if="trigger === 'hover'" class="flex-1 cursor-pointer" @mouseenter="openDropdown" @mouseleave="closeDropdown" :class="triggerClasses" ref="dropdownTrigger">
            <slot v-if="!modelValueIsset"></slot>
            <div v-else class="px-2 py-1 rounded border text-gray-600 text-xs">
                <i v-if="icon" :class="icon"></i>
                {{ getText(modelValue) }}
                <button v-if="modelValue" @click="$event.stopPropagation(); emit('update:modelValue', null)">
                    <i class="fal fa-times fa-fw"></i>
                </button>
                <i v-else class="fal fa-chevron-down fa-fw"></i>
            </div>
        </div>
        <div v-else-if="trigger === 'manual'" class="flex-1 cursor-pointer" :class="triggerClasses" ref="dropdownTrigger">
            <slot v-if="!modelValueIsset"></slot>
            <div v-else class="px-2 py-1 rounded border text-gray-600 text-xs">
                <i v-if="icon" :class="icon"></i>
                {{ getText(modelValue) }}
                <button v-if="modelValue" @click="$event.stopPropagation(); emit('update:modelValue', null)">
                    <i class="fal fa-times fa-fw"></i>
                </button>
                <i v-else class="fal fa-chevron-down fa-fw"></i>
            </div>
        </div>
    <!-- </div> -->

        <template #content="{ hide }">
            <div ref="pickerDropdown" 
                class="p-px rounded-md shadow-lg flex flex-col overflow-hidden bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                :class="[maxWidth ? maxWidth : 'w-64', maxHeight ? maxHeight : 'max-h-52', classes, origin ? origin : 'origin-top-right']">
            
                <slot name="header" :close="closePickerOutside" :hideFn="hide" :updateFn="updatePosition"></slot>

                <div v-if="showSearch" class="border-b">
                    <input type="text" v-model="searchTerm" placeholder="Suche ..." class="border-none text-sm w-full focus:ring-0 focus:border-none" ref="searchInput" @keydown.esc="theTippy.hide()">
                </div>

                <div v-if="!custom" class="p-1 overflow-y-auto">

                    <tippy v-for="(item,i) in filteredItems" class="relative block text-left" 
                        theme="transparent" :arrow="false" interactive animation="shift-away" placement="right"
                        :offset="[0, 0]" :maxWidth="maxWidth" :touch="true"> <!-- :appendTo="docBody" :offset="offset" :onShown="tippyShown" :onHidden="tippyHidden" ref="theTippy" -->

                        <a :key="`dropdown-item-${i}`" @click="select(item, i, hide)"
                            :class="[item.textClasses || 'text-gray-700 hover:text-gray-900', 'block px-2.5 py-2 text-sm cursor-pointer rounded-md', {'hover:bg-gray-100': !item.disabled}]">
                            <span v-if="item.indent">{{ '&nbsp;&nbsp;&nbsp;&nbsp;'.repeat(item.indent) }}</span>
                            <i v-if="item.icon" :class="item.icon" class="mr-1"></i>
                            {{item.text}}
                            <span v-if="item.subtext" class="block text-xs text-gray-500">{{ item.subtext }}</span>
                        </a>

                        <template #content="{ hide }">
                            <div v-if="item.children" class="bg-white rounded-md shadow-lg border overflow-hidden p-1">
                                <a  
                                    :class="[item.textClasses || 'text-gray-700 hover:text-gray-900', 'block px-2.5 py-2 text-sm cursor-pointer rounded-md', {'hover:bg-gray-100': !item.disabled}]">
                                    <!-- <span v-if="item.indent">{{ '&nbsp;&nbsp;&nbsp;&nbsp;'.repeat(item.indent) }}</span>
                                    <i v-if="item.icon" :class="item.icon" class="mr-1"></i>
                                    {{item.text}} -->
                                    Test
                                </a>
                            </div>
                        </template>
                    
                    </tippy>

                </div>
                <div v-else class="divide-y divide-gray-100 overflow-y-auto" :class="listClasses">
                    <div v-for="(item,i) in filteredItems" :key="`custom-dropdown-item-${i}`">
                        <slot name="item" :item="item" :indx="i" :close="closePickerOutside" :hideFn="hide" :updateFn="updatePosition"></slot>
                    </div>
                </div>

                <slot name="footer" :close="closePickerOutside" :hideFn="hide" :updateFn="updatePosition"></slot>

            </div>
        </template>
    </tippy>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
const props = defineProps({
    tag: {type: String, default: 'span'},
    modelValue: {type: [Object, String, Number], default: undefined},
    icon: {type: String, default: ''}, 
    items: {type: Array, default: []},
    maxWidth: {type: String, default: ''},
    maxHeight: {type: String, default: ''},
    custom: {type: Boolean, default: false},
    placement: {type: String, default: ''}, 
    classes: {type: String, default: ''},
    wrapperClasses: {type: String, default: ''},
    triggerClasses: {type: String, default: ''},
    listClasses: {type: String, default: ''},
    offset: {type: Object, default: [0, 0]},
    origin: {type: String, default: 'origin-top-right'},
    temporarilyFixed: {type: Boolean, default: false},
    trigger: {type: String, default: 'click'},
    disabled: {type: Boolean, default: false},
    waitForHide: {type: Boolean, default: false},
    loaderWhileWaiting: {type: Boolean, default: false},
    showSearch: {type: Boolean, default: false},
    // CSS-Transition für den Popper, wenn er seine Position ändert (z.B. via updatePosition), etwa 'transform 0.2s ease-out'
    moveTransition: {type: String, default: ''},
})
const emit = defineEmits(['select', 'update:modelValue'])

const dropdownTrigger = ref()
const pickerDropdown = ref()
const theTippy = ref()
const dropdownOpen = ref(false)
const dropdownPosition = ref({top: 0, left: 0})
const searchTerm = ref('')
const searchInput = ref()
const docBody = document.body

const modelValueIsset = computed(() => typeof props.modelValue !== 'undefined')

const filteredItems = computed(() => {
    return props.items.filter(item => searchTerm.value ? item.text?.toLowerCase()?.includes(searchTerm.value.toLowerCase()) : true)
})

const getText = (val) => {
    return props.items.find(item => `${item.value}` === `${val}`)?.text || val
}

const tippyShow = () => {
    return !props.disabled
}
const tippyShown = () => {
    if(props.showSearch) searchInput.value.focus()
}
const tippyHidden = () => {
    searchTerm.value = ''
}

// watch(dropdownOpen, async(newState, oldState) => {
//     setTimeout(() => {
//         if(newState) {
//             document.body.addEventListener('click', closePickerOutside)
//             // pickerDropdown.value.style.top = `calc(${pickerDropdown.value.getBoundingClientRect().top 
//             //     - (pickerDropdown.value.parentNode.closest('.overflow-y-auto')?.getBoundingClientRect()?.top || 0) 
//             //     - parseInt(getComputedStyle(pickerDropdown.value).marginTop.replace('px', ''))}px - 0.5rem)`;

//             // pickerDropdown.value.style['top'] = `calc(
//             //     ${pickerDropdown.value.getBoundingClientRect().top}px
//             //      - ${((pickerDropdown.value.parentNode.closest('.overflow-y-auto')?.getBoundingClientRect()?.top || 0) + 
//             //      (pickerDropdown.value.parentNode.closest('.overflow-y-auto')?.scrollTop || 0))}px - 1rem
//             // )`;


//             pickerDropdown.value.style['top'] = `${dropdownPosition.value.top + 25 + (props.offset.y || 0)}px`

//             let triggerRect = dropdownTrigger.value.getBoundingClientRect();
//             if(props.origin.includes('right')) {
//                 pickerDropdown.value.style['right'] = `calc(${(window.innerWidth - triggerRect.left - triggerRect.width
//                     - pickerDropdown.value.parentNode.closest('.overflow-y-auto')?.getBoundingClientRect()?.left || 0
//                     ) + (props.offset.x || 0)}px)`;
//             } else {
//                 pickerDropdown.value.style['left'] = `calc(${(triggerRect.left 
//                     - pickerDropdown.value.parentNode.closest('.overflow-y-auto')?.getBoundingClientRect()?.left || 0
//                     ) + (props.offset.x || 0)}px)`;
//             }
//         } else {
//             document.body.removeEventListener('click', closePickerOutside)
//         }
//     }, 1);
// })

const openDropdown = (e) => {
    if(!props.disabled && (props.trigger !== 'click' || !e)) {
        theTippy.value?.show()
        // dropdownPosition.value = e.target.getBoundingClientRect()
        // dropdownPosition.value = dropdownTrigger.value.getBoundingClientRect()
        // dropdownOpen.value = true
    }
}
const closeDropdown = (e) => {
    theTippy.value?.hide()
    // dropdownOpen.value = false
}
// Popper-Position zur Laufzeit neu berechnen, z.B. wenn sich der Inhalt des Dropdowns in der Höhe ändert
const updatePosition = async () => {
    await nextTick()
    await theTippy.value?.tippy?.popperInstance?.update()
}
const closePickerOutside = (event) => {
    if(!pickerDropdown.value?.contains(event?.target) && !props.temporarilyFixed) {
        dropdownOpen.value = false;
    }
}
const select = (item, indx, hideFn) => { // console.log(item);
    if(item.disabled) return;
    emit('select', item, hideFn)
    if(props.waitForHide) {
        // if(props.loaderWhileWaiting) {
        //     let test = [...pickerDropdown.value.querySelectorAll(`a > i`)]
        //     console.log(test[indx]);
        //     test[indx].classList = 'far fa-spinner-third fa-spin fa-fw mr-1'
        // }
    } else {
        dropdownOpen.value = false
        hideFn();
    }
}
defineExpose({
    openDropdown,
    closeDropdown,
    updatePosition
})
</script>